import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';

@Injectable({
  providedIn: "root"
})
export class NewDashboardDirectionService {
  constructor(private _restClientService: RestClientService) {}


  getDossiersDirectionStatus(
    direction: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-direction/dossiers-direction-status?filter=${filter}&page=${pageIndex}&size=${pageSize}&direction=${direction}`
    );
  }

  getDossiersDirectionEnCours(
    direction: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-direction/dossiers-direction-en-cours?filter=${filter}&page=${pageIndex}&size=${pageSize}&direction=${direction}`
    );
  }

  getDossiersDirectionEnRetard(
    direction: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-direction/dossiers-direction-en-retard?filter=${filter}&page=${pageIndex}&size=${pageSize}&direction=${direction}`
    );
  }

  getDossiersDirectionMiseEnPlace(
    direction: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-direction/dossiers-direction-mise-en-place?filter=${filter}&page=${pageIndex}&size=${pageSize}&direction=${direction}`
    );
  }

  getDossiersDirectionEnCorrection(
    direction: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-direction/dossiers-direction-en-correction?filter=${filter}&page=${pageIndex}&size=${pageSize}&direction=${direction}`
    );
  }
}